import React from "react";

const FoundSimilars = ({ results, type }) => {
  return (
    <div
      className="divColumn"
      style={{ position: "absolute", top: 5, right: 0, marginRight: "40px" }}
    >
      <div className="textBold">Similar {type}</div>
    </div>
  );
};

export default FoundSimilars;
